var map = {
	"./China.png": "1273",
	"./_argentina.png": "248d",
	"./_australia.png": "2239",
	"./_austria.png": "c0c5",
	"./_belarus.png": "74c0",
	"./_bolivia.png": "5707",
	"./_brazil.png": "bf08",
	"./_canada.png": "be35",
	"./_chile.png": "66b0",
	"./_china.png": "56efe",
	"./_costarica.png": "53c0",
	"./_denmark.png": "ff8b",
	"./_france.png": "0865",
	"./_germany.png": "3695",
	"./_hungary.png": "d8c2",
	"./_india.png": "5b542",
	"./_ireland.png": "8b22",
	"./_italy.png": "6532",
	"./_kazakhstan.png": "2c37",
	"./_latvia.png": "8548",
	"./_lithuania.png": "257a",
	"./_mexico.png": "b4be",
	"./_mongolia.png": "9ed5",
	"./_namibia.png": "3671",
	"./_netherlands.png": "2ea1",
	"./_newzealand.png": "080b",
	"./_othercountry.png": "3687",
	"./_panama.png": "6e03",
	"./_portugal.png": "6990",
	"./_russia.png": "06a9",
	"./_serbia.png": "976d",
	"./_southafrica.png": "3fb3",
	"./_spain.png": "bb34",
	"./_ukraine.png": "21963",
	"./_unitedkingdom.png": "e4f6",
	"./_unitedstates.png": "460a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0fa7";